import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUbereats = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 60 60",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("circle", {
			cx: 30,
			cy: 30,
			r: 30,
			fill: "#06C167"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M28.8,40c0-1.7-1.3-3.1-3-3.1c-1.7,0-3.1,1.3-3.1,3s1.3,3.1,3,3.1h0C27.4,43.1,28.8,41.7,28.8,40L28.8,40 M31.3,35.1V45 h-2.5v-0.9c-0.9,0.7-2,1.1-3.2,1.1c-3,0-5.3-2.3-5.3-5.2c0-2.9,2.3-5.2,5.3-5.2c1.2,0,2.3,0.4,3.2,1.1v-0.9 C28.7,35.1,31.3,35.1,31.3,35.1z M39.7,42.7h-1.9c-0.6,0-0.9-0.2-0.9-0.8v-4.6h2.9v-2.2h-2.9v-2.8h-2.5v2.8h-1.9v2.2h1.9v5.2 c0,1.3,1,2.4,2.7,2.4h2.7C39.7,45,39.7,42.7,39.7,42.7z M45.4,45.2c2.9,0,4.6-1.4,4.6-3.3c0-1.3-1-2.3-3-2.8l-2.2-0.4 c-1.3-0.2-1.6-0.5-1.6-0.9c0-0.6,0.6-1,1.7-1c1.2,0,2.1,0.3,2.3,1.4h2.5c-0.1-2-1.6-3.4-4.7-3.4c-2.6,0-4.5,1.1-4.5,3.1 c0,1.4,1,2.4,3.2,2.8l2.4,0.5c1,0.2,1.2,0.4,1.2,0.8c0,0.6-0.7,1-1.9,1c-1.5,0-2.3-0.3-2.6-1.4h-2.5C40.7,43.8,42.3,45.2,45.4,45.2 M10,31.6h9.5v2.3h-7v3.3h6.8v2.2h-6.8v3.3h7V45H10V31.6z M49.8,20.1v-1.8h-0.7c-1.1,0-1.9,0.5-2.4,1.3v-1.2h-1.9v9.7h2v-5.5 c0-1.5,0.9-2.5,2.2-2.5C48.9,20.1,49.8,20.1,49.8,20.1z M35.7,22.4c0.3-1.5,1.6-2.5,3-2.5s2.7,1,3,2.5H35.7z M38.8,18.2 c-2.8,0-5.1,2.2-5.1,5v0c0,2.9,2.3,5.1,5.2,5.1c1.8,0,3.3-0.8,4.3-2.1l-1.4-1c-0.7,1-1.7,1.4-2.8,1.4c-1.6,0-3-1.2-3.3-2.8h8v-0.6 C43.7,20.4,41.6,18.2,38.8,18.2 M27.6,26.6c-1.9,0-3.4-1.5-3.3-3.4s1.5-3.4,3.4-3.3c1.8,0,3.3,1.5,3.3,3.4 C31,25.1,29.4,26.6,27.6,26.6L27.6,26.6 M22.3,28.1h1.9v-1.2c0.9,0.9,2.2,1.5,3.5,1.4c2.9,0,5.2-2.3,5.2-5.1c0-2.8-2.3-5.1-5.2-5.1 c-1.3,0-2.6,0.5-3.5,1.4v-4.8h-2V28.1z M15.4,26.5c1.9,0,3.3-1.4,3.3-3.5v-8.2h2v13.3h-2v-1.2c-0.9,0.9-2.2,1.5-3.6,1.5 c-2.9,0-5.1-2.1-5.1-5.2v-8.3h2V23C12,25.2,13.5,26.5,15.4,26.5",
			fill: "#000"
		})
	]
});
const ForwardRef = forwardRef(SvgUbereats);
export { ForwardRef as ReactComponent };
